<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #description>
            <div class="signs__description">
                <span v-for="([text, icon]) in Object.entries(icons)" 
                    :key="text"
                >
                    <v-icon :class="`multiple-signal--${icon.color}`">
                        {{ icon.name }}
                    </v-icon>
                    {{ text }}
                </span>
            </div>
        </template>

        <template #signs>
            <MonitorMultipleSigns v-if="sign_data"
                :data="sign_data"
            />
        </template>

        <template #data_table>
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :props_date="date"
                :props_time="time"
                :should_show_raw_html_header="should_show_raw_html_header"
                :show_download_pdf_btn="show_download_pdf_btn"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            >
                <template #table_description>
                    <div 
                        v-for="({ text, name, display_info }) in icons_table_description" 
                        :key="text"
                    >
                        {{ text }}<br>
                        <span
                            v-for="([alert_text, value]) in Object.entries(display_info)"
                            :key="`${text}_${alert_text}`"
                        >
                            {{ alert_text }}：
                            <v-icon 
                                :class="`multiple-signal--${value.color}`"
                            >
                                {{ name }}
                            </v-icon>
                        </span>
                    </div>
                    <div>
                        說明:<br>
                        1. 「--」 表示該欄位無資料。<br>
                        2.雨量資料問題請撥打(02)2349-7972。<br>
                    </div>
                </template>
            </QpeDatatable>
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { 
        icons,
        reconstruct_signs_structure,
    } from "@/utils/monitor/customization/thsr.js"
    import { 
        reconstruct_alert_icon,
    } from "@/utils/monitor/multiple_signs.js"
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "../../../config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorMultipleSigns from "@/components/monitor/_tool/monitor_multiple_signs.vue"
    import QpeDatatable from "@/components/monitor/qpe_datatable.vue";
    
    export default {
        name: 'ThsrMonitor',

        components: { 
            MonitorLayoutTemplate,
            QpeDatetime,
            MonitorMultipleSigns,
            QpeDatatable,
        },

        mixins: [ 
            monitor_mixin
        ],

        props: {
            default_value: {
                type: Number,
                required: true
            },

            in_overview_page: {
                type: Boolean,
                default: false
            },

            show_download_pdf_btn: {
                type: Boolean,
                default: false,
            }
        },

        data() {
            return {
                header: [],
                immutable_table_data: [],
                table_data: [],
                error_text: '',

                should_show_raw_html_header: ['警示'],

                TABLE_VALUE_TEXT_MAPPING: TABLE_VALUE_TEXT_MAPPING,

                icons: icons,
            }
        },

        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            },

            sign_data() {
                return this.immutable_table_data.length 
                    ? reconstruct_signs_structure(this.immutable_table_data) 
                    : []
            },

            icons_table_description() {
                return Object.entries(icons).map(([key, value]) => {
                    const { show_opacity, color, name, ...display_info} = value;
                    return {
                        text: key,
                        name,
                        display_info
                    };
                })
            }
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = reconstruct_alert_icon(data, icons);
                this.header = header;

                if (this.in_overview_page) {
                    this.table_data = data.filter(({ alert_order }) => alert_order === 0);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/monitor/sign';

    .signs {
        &__description {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>